<template>
  <div class="hover07">
    <figure class="banner">
      <img class="img" :src="require(`@/assets/images/${image}.jpg`)" />
      <!-- <v-parallax class="img" :src="require(`@/assets/images/${image}.jpg`)">
      </v-parallax> -->
    </figure>
  </div>
</template>

<script>
  export default {
    name:'banner',
    props:{
      image:{
        type:String,
        default:'hada'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Amatic+SC:400,700&display=swap');
figure {
	margin: 0;
	padding: 0;
	background: #fff;
	overflow: hidden;
  position: relative;
  height:200px;
  @media screen and (max-width:900px){
     height: 100px;
  }
}
.img{
   width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
     background-attachment: fixed;
   @media screen and (max-width:960px){
     height: 100px !important;
   }
}
.hover07 figure .img {
	-webkit-filter: blur(4px);
	filter: blur(4px);
}

</style>